import { Clickable } from '@carvana/vdp-components';
import classNames from 'classnames';
import { forwardRef } from 'react';

const formattedTestHook = facetName => {
  const strippedName = facetName.split(' ').join('');

  return `filters.expand${strippedName}Button`;
};

type OwnProps = {
  className?: string;
  dataQa: string;
  expand: boolean;
  onToggle: () => void;
  text: string;
};

function ListItemHeader(
  { className, dataQa, expand, onToggle, text }: OwnProps,
  ref
) {
  const elementId = formattedTestHook(dataQa);

  return (
    <Clickable
      className={classNames(
        'border-0 border-grey-2 border-solid border-t flex items-center justify-between px-32 py-24 relative text-left transition-shadow w-full',
        className,
        { 'shadow-v300': expand }
      )}
      onClick={onToggle}
      data-qa={elementId}
      data-analytics-id={elementId}
      elementRef={ref}
    >
      <p className="mb-0 t-header-s text-blue-6 uppercase">{text}</p>
      <svg
        className={classNames(
          { 'rotate-180': expand },
          'h-24 text-blue-2 w-24'
        )}
        viewBox="-5 -8 20 20"
      >
        <g id="arrow-down-10x6-blue">
          <path
            d="M0,.81a.78.78,0,0,0,.23.55L4.52,5.74A.9.9,0,0,0,5.16,6a.88.88,0,0,0,.63-.28l4-4.38A.77.77,0,0,0,9.71.2a.88.88,0,0,0-1.2.08L5.13,4,1.48.26A.88.88,0,0,0,.27.22.78.78,0,0,0,0,.81"
            fill="#00aed9"
          />
        </g>
      </svg>
    </Clickable>
  );
}

export default forwardRef(ListItemHeader);
